
import { Box } from '@mui/system';
import React, { useState, useEffect, useCallback } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid } from 'recharts';
import styles from './softwareGraphComponent.module.scss';
import i18next from "i18next";
import { Tab, Tabs, Typography } from "@mui/material";
import _ from "lodash";
import { API_URL } from '../../../../config/appConfig';
import RemoteService from '../../../../services/RemoteService';
import { useApiErrorModalContext } from "../../../../errorHandling/ApiErrorModalContext";

const softwareCodeMapping = {
"Onbekend": "NB",
"Autodata WheelerDelta": "AWD",
"AutotelexPro": "ATX", 
"Advertentiemanager": "VWE",
"OBS-VM": "OBS",
"Used Car Controller": "UCC",
"Mobilox": "MOX",
"Autosoft" : "ASF",
"AutoPresentatie": "APR",
"Cargo Export" : "CRG"
};

export default function SoftwareGraphComponent() {
  const [selectedTab, setSelectedTab] = useState(3);
  const [dashboardSoftwareSystemList, setDashboardSoftwareSystemList] = useState([]);
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const { setApiErrorModalState } = useApiErrorModalContext();
  const getDashboardSoftwareSystemList = useCallback(() => {
    const url = `${API_URL}/api/SoftwareSystem/GetDashboardSoftwareSystemList?period=${selectedTab}`;
    RemoteService.send(url, "").then((response) => {
      if (!_.isEmpty(_.get(response, "errorMessage", "")) || _.get(response, "success", true) === false) {
        _.set(response, "status", 200);

        setApiErrorModalState({ error: response });
      } else {
        setDashboardSoftwareSystemList(response.data);
      }
    });
  }, [selectedTab, setApiErrorModalState]);

  useEffect(() => {
    getDashboardSoftwareSystemList();
  }, [getDashboardSoftwareSystemList, selectedTab]);

  const processedData = dashboardSoftwareSystemList.map(item => ({
    softwareCode: softwareCodeMapping[item.key],
    value: item.value
  }));
  
  return (
    <Box data-testid="SoftwareGraphComponent" >
      <Box className={styles.graphTableContainer} >
        <Box>
          <Typography variant="h1" className={styles.heading}>{i18next.t("Dealers from Software systems")}</Typography>
        </Box>
        <Box className={styles.tabContainerheader}>
          <Tabs value={selectedTab} onChange={handleTabChange} className={styles.toggelStyle} sx={{
            boxShadow: '0px 2px 4px 0px rgba(96, 97, 112, 0.16),0px 0px 1px 0px rgba(40, 41, 61, 0.04)'
          }}>
            <Tab label={i18next.t("Monthly")} className={styles.selectedDay} value={3} />
            <Tab label={i18next.t("Yearly")} className={styles.selectedDay} value={4} />
          </Tabs>
        </Box>
      </Box>
      <BarChart width={558} height={226} data={processedData} className={styles.barChartContainer}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="softwareCode" />
        <YAxis dataKey="value" axisLine={false} />
        <Bar dataKey="value" fill="#0B72D9" />
      </BarChart>
    </Box>
  );
}
